import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import SignupForm from "./components/signup";
import Login from "./components/login";
import ForgotPassword from "./components/forgotpassword";
import VerifyCode from "./components/verifycode";
import LoginForgotPassword from "./components/login";
import HomePage from "./components/homepage";
import ResetPassword from "./components/resetpassword";
import Auth from "./components/Auth";
import FriendsFollowers from "./components/friendsfollowers";
import VerifyCodeSignup from "./components/verifycodeforsignup";
import Ordermanagement from "./components/myorder/ordermanagement";
import OrderDetail from "./components/myorder/OrderDetail";
// import HomePageNew from "./components/homenew";
import Myprofile from "./components/profile";
import GoogleAuthCallback from "./components/googleAuth";
import Navbar from "./components/sidebar/leftsidebar";
import Groupsandfamily from "./components/groupsandfamily";
import "./index.css";
import "flowbite";
import Profileedit from "./components/profileedit";
import VerifyCodeMobile from "./components/verifycodemobile";
import Signinwithmobile from "./components/signinwithmobile";
import Golive from "./components/golive";
import GoliveDonation from "./components/golivedonation";
import Account from "./components/Account";
import { SearchProvider } from "./context/SearchContext";
import Viewpost from "./components/feedpost/viewpost";
import TermsConditions from "./components/TermsConditions";
import TermsConditionsMobile from "./components/TermsConditionsMobile";

import ProfileView from "./components/profileview";
import Profilefollowers from "./components/profilefollowers";
import Donation from "./components/donation";
import React, { useEffect } from "react";
import { messaging, getToken, onMessage } from "./components/firebase-config";
import AboutUsDetail from "./components/AboutUsDetail";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PostDetailPage from "./components/PostDetailPage"; // 👈 create this
import DeepLinkRedirect from "./components/DeepLinkRedirect";
import ShortLinkRedirect from "./components/ShortLinkRedirect";
// import ProtectedRoute from "./components/ProtectedRoute";
import Wallet from "./components/wallet";
import AboutUs from "./components/AboutUs";
import Help from "./components/Help";
import SellerInformation from "./components/sellerInformation/SellerInformation";
import Profile from "./components/SellProfile/Profile";
import Buyer from "./components/shopbuye/Buyer";
import Buyers from "./components/shopbuyeformarketplace/Buyer";

import Seller from "./components/becomesell/Seller";
import CustomView from "./components/customshop/CustomView";
import FundPage from "./components/fundraiseing/FundPage";
import NotificationPage from "./components/notification/NotificationPage";
import StoryBar from "./components/story/StoryBar";
import DonationPage from "./components/donation";
import ProtectedRoute from "./components/common/ProtectedRoute";
import PublicRoute from "./components/common/PublicRoute";
import ChatsPage from "./components/common/ChatsPage";
import { SocketProvider } from "./contexts/SocketContext";
import { GoliveProduct } from "./components/becomesell/GoliveProduct";
import Checkout from "./components/becomesell/Checkout";
import ShopperAdders from "./components/becomesell/ShopperAdders";
import OrderReceipt from "./components/becomesell/OrderReceipt";
import PaymentFail from "./components/becomesell/PaymentFail";
import BuySellerView from "./components/becomesell/BuySellerView";
import Bcomeseller from "./components/sellerInformation/Bcomeseller";
import JoinLive from "./components/JoinLive";
import JoinLivePage from "./components/JoinLivePage";
import MarketPage from "./components/marketplace/MarketPage";
import ShopPage from "./components/shopeing/ShopPage";
import CartPage from "./components/shopeing/CartPage";
import CartPageSeller from "./components/shoppingbuyer/CartPage";

import ProductView from "./components/shopeing/ProductView";
import OrderReviewPage from "./components/ordereview/OrderReviewPage";
import OrderPage from "./components/myorder/OrderPage";
import AllSellersPage from "./components/marketplace/AllSellersPage";
import UserOrders from "./components/myorder/UserOrders";
import AdCampaignManager from "./components/ads/AdCampaignManager";
import AdAccountTypeSelect from "./components/ads/AdAccountTypeSelect";
import AddAdAccount from "./components/ads/AddAdAccount";
import CreateAdCampaign from "./components/ads/CreateAdCampaign";
import AdSubmittedSuccess from "./components/ads/AdSubmittedSuccess";
import ViewCampaign from "./components/ads/ViewCampaign";
import ViewAdSet from "./components/ads/ViewAdSet";
import ViewAd from "./components/ads/ViewAd";
import EditAd from "./components/ads/EditAd";
import CreateAdSetPage from "./components/ads/CreateAdSetPage";
import CreateAdPage from "./components/ads/CreateAdPage";
import AdBillingDashboard from "./components/ads/billing/AdBillingDashboard";
import AdBillingModel from "./components/ads/billing/AdBillingModel";
import AdTaxBillingInfo from "./components/ads/billing/AdTaxBillingInfo";
import AdAddCredits from "./components/ads/billing/AdAddCredits";
import AdPaymentMethods from "./components/ads/billing/AdPaymentMethods";
import AdInvoices from "./components/ads/billing/AdInvoices";
import AdSpendingControls from "./components/ads/billing/AdSpendingControls";
import AdPostpaidSetup from "./components/ads/billing/AdPostpaidSetup";
export default function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("✅ Service Worker registered");

          Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
              getToken(messaging, {
                vapidKey:
                  "BM4Lm-Z02wa63w6mLl_5mmGANpi02V_x4tQqqKIQqtEOjHFymNn7-NoRb5-312kiIyOBD6gcXM5rSH7ZIyLd4mU",
                serviceWorkerRegistration: registration, // ✅ important
              })
                .then((currentToken) => {
                  if (currentToken) {
                    console.log("✅ FCM Token:", currentToken);
                    // Send to backend if needed
                  } else {
                    console.warn("⚠️ No registration token available.");
                  }
                })
                .catch((err) => {
                  console.error("❌ Error retrieving token:", err);
                });
            }
          });

          // Foreground messages
          onMessage(messaging, (payload) => {
            console.log("📩 Foreground message received:", payload);
            alert(
              `${payload.notification.title}: ${payload.notification.body}`,
            );
          });
        })
        .catch((err) => {
          console.error("❌ Service Worker registration failed:", err);
        });
    }
  }, []);
  const streamId = "stream_1761132073103_c63c5263996a6b51";

  const stripePromise = loadStripe(
    "pk_test_51RblDNQATYe2Rh6GiaIHcxmlRG5vE7e0wCyytrh72oAj3fITq7mhkqZeVQJ0HGmiffn3UZkc0spIl5cM0iOfF84f00xvDruQKV",
  ); // Replace with your actual key

  return (
    <SearchProvider>
      <Router>
        <div className="flex flex-col items-center justify-center min-h-screen">
          {/* <h1 className="text-3xl font-bold text-gray-700 mb-6">Welcome</h1> */}
          <div className="flex space-x-4">
            {/* <Link to="/login" className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600">
              Login
            </Link>
            <Link to="/signup" className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600">
              Signup
            </Link> */}
          </div>
          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            <Route path="/signup" element={<SignupForm />} />

            <Route
              path="/login"
              element={
                // <ProtectedRoute>
                <Login />
                // </ProtectedRoute>
              }
            />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/verifycode" element={<VerifyCode />} />
            <Route path="/login" element={<LoginForgotPassword />} />
            {/* <Route path="/post/:id" element={<PostDetailPage />} /> */}
            {/* For stories */}
            <Route path="/story/:id" element={<StoryBar />} />

            {/* For donations */}
            {/* <Route path="/donation/:id" element={<DonationPage />} /> */}
            <Route
              path="/home"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/post/:id"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/donation/:id"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                </Elements>
              }
            />
            {/* <Route path="/chats" element={<ChatsPage  />} /> */}
            <Route
              path="/chats"
              element={
                <ProtectedRoute>
                  <SocketProvider>
                    <ChatsPage />
                  </SocketProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Wallet />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/auth" element={<Auth />} />
            <Route
              path="/friendsfollowers"
              element={
                <ProtectedRoute>
                  <FriendsFollowers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verifycodeforsignup"
              element={
                // <ProtectedRoute>
                <VerifyCodeSignup />
                // </ProtectedRoute>
              }
            />
            {/* <Route path="/homenew" element={<HomePageNew />} /> */}
            <Route
              path="/myprofile"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Myprofile />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/navbar"
              element={
                <ProtectedRoute>
                  <Navbar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/auth/callback"
              element={
                <ProtectedRoute>
                  <GoogleAuthCallback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/signtest"
              element={
                <ProtectedRoute>
                  <GoogleAuthCallback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verifycodemobile"
              element={
                // <ProtectedRoute>
                <VerifyCodeMobile />
                // </ProtectedRoute>
              }
            />
            <Route
              path="/myprofileedit"
              element={
                <ProtectedRoute>
                  <Profileedit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/groupsfamily"
              element={
                <ProtectedRoute>
                  <Groupsandfamily />
                </ProtectedRoute>
              }
            />
            <Route
              path="/signinwithmobile"
              element={
                // <ProtectedRoute>
                <Signinwithmobile />
                // </ProtectedRoute>
              }
            />
            <Route path="/my-orders" element={<UserOrders />} />
            <Route path="/order/:id" element={<OrderDetail />} />
            <Route
              path="/account"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/golive"
              element={
                <ProtectedRoute>
                  <Golive />
                </ProtectedRoute>
              }
            />
            <Route
              path="/golivedonation"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <GoliveDonation />
                  </ProtectedRoute>
                </Elements>
              }
            />
            {/* <JoinLive streamId={streamId} /> */}
            <Route
              path="/joinlive/:streamId"
              element={
                <ProtectedRoute>
                  <JoinLive />
                </ProtectedRoute>
              }
            />
            <Route
              path="/joinlive/:streamId"
              element={
                <ProtectedRoute>
                  <JoinLivePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/viewpost"
              element={
                <ProtectedRoute>
                  <Viewpost />
                </ProtectedRoute>
              }
            />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route
              path="/terms-conditions-mobile"
              element={<TermsConditionsMobile />}
            />

            <Route
              path="/myprofile/:id"
              element={
                <ProtectedRoute>
                  <ProfileView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profilefollowers"
              element={
                <ProtectedRoute>
                  <Profilefollowers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/donation"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <Donation />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/aboutus"
              element={
                <ProtectedRoute>
                  <AboutUs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/about-us-detail"
              element={
                <ProtectedRoute>
                  <AboutUsDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/help"
              element={
                <ProtectedRoute>
                  <Help />
                </ProtectedRoute>
              }
            />

            <Route
              path="/becomeaseller"
              element={
                <ProtectedRoute>
                  <Bcomeseller />
                </ProtectedRoute>
              }
            />

            <Route
              path="/sellerInformation"
              element={
                <ProtectedRoute>
                  <SellerInformation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sellprofile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminseller"
              element={
                <ProtectedRoute>
                  <Seller />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buybellerview"
              element={
                <ProtectedRoute>
                  <BuySellerView />
                </ProtectedRoute>
              }
            />

            <Route
              path="/goliveseller"
              element={
                <ProtectedRoute>
                  <GoliveProduct />
                </ProtectedRoute>
              }
            />

            <Route
              path="/addshopperadders"
              element={
                <ProtectedRoute>
                  <ShopperAdders />
                </ProtectedRoute>
              }
            />

            <Route
              path="/addshopperaddress"
              element={
                <ProtectedRoute>
                  <ShopperAdders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/marketplace"
              element={
                <ProtectedRoute>
                  <MarketPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shoppage"
              element={
                <ProtectedRoute>
                  <ShopPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cart"
              element={
                <ProtectedRoute>
                  <CartPage />
                </ProtectedRoute>
              }
            />
            <Route path="/allsellers" element={<AllSellersPage />} />

            <Route
              path="/cartpageseller"
              element={
                <ProtectedRoute>
                  <CartPageSeller />
                </ProtectedRoute>
              }
            />
            <Route
              path="/productview"
              element={
                <ProtectedRoute>
                  <ProductView />
                </ProtectedRoute>
              }
            />
            <Route path="/ProductView/:id" element={<ProductView />} />
            <Route
              path="/profilecheckout"
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ordereview"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <OrderReviewPage />
                  </ProtectedRoute>
                </Elements>
              }
            />

            <Route
              path="/orderReceipt"
              element={
                <ProtectedRoute>
                  <OrderReceipt />
                </ProtectedRoute>
              }
            />

            <Route
              path="/paymentfail"
              element={
                <ProtectedRoute>
                  <PaymentFail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/myorder"
              element={
                <ProtectedRoute>
                  <OrderPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/shpebuye"
              element={
                <ProtectedRoute>
                  <Buyer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shopbuyeformarketplace"
              element={
                <ProtectedRoute>
                  <Buyers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customview"
              element={
                <ProtectedRoute>
                  <CustomView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fundraiseing"
              element={
                <ProtectedRoute>
                  <FundPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Notification"
              element={
                <ProtectedRoute>
                  <NotificationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ordermanagement"
              element={
                <ProtectedRoute>
                  <Ordermanagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream/:streamId"
              element={
                <Elements stripe={stripePromise}>
                  <GoliveDonation viewerMode={true} />
                </Elements>
              }
            />

            <Route
              path="/ads"
              element={
                <ProtectedRoute>
                  <AdCampaignManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing"
              element={
                <ProtectedRoute>
                  <AdBillingDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/model"
              element={
                <ProtectedRoute>
                  <AdBillingModel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/tax-profile"
              element={
                <ProtectedRoute>
                  <AdTaxBillingInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/add-credits"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <AdAddCredits />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/ads/billing/payment-methods"
              element={
                <Elements stripe={stripePromise}>
                  <ProtectedRoute>
                    <AdPaymentMethods />
                  </ProtectedRoute>
                </Elements>
              }
            />
            <Route
              path="/ads/billing/invoices"
              element={
                <ProtectedRoute>
                  <AdInvoices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/spending-controls"
              element={
                <ProtectedRoute>
                  <AdSpendingControls />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/billing/postpaid-setup"
              element={
                <ProtectedRoute>
                  <AdPostpaidSetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/select-account"
              element={
                <ProtectedRoute>
                  <AdAccountTypeSelect />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/add-account"
              element={
                <ProtectedRoute>
                  <AddAdAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/create"
              element={
                <ProtectedRoute>
                  <CreateAdCampaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/submitted-success"
              element={
                <ProtectedRoute>
                  <AdSubmittedSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/campaigns/:campaignId"
              element={
                <ProtectedRoute>
                  <ViewCampaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/campaigns/:campaignId/ad-sets/new"
              element={
                <ProtectedRoute>
                  <CreateAdSetPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ad-sets/:adSetId"
              element={
                <ProtectedRoute>
                  <ViewAdSet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ad-sets/:adSetId/ads/new"
              element={
                <ProtectedRoute>
                  <CreateAdPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ads/:adId"
              element={
                <ProtectedRoute>
                  <ViewAd />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ads/ads/:adId/edit"
              element={
                <ProtectedRoute>
                  <EditAd />
                </ProtectedRoute>
              }
            />

            {/* You can add a Login component here later */}
          </Routes>
        </div>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </SearchProvider>
  );
}
